import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';

import {AdminUserDetailPageComponent} from './admin-user-detail.page';

const routes: Routes = [
  {
    path: '',
    component: AdminUserDetailPageComponent
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AdminUserDetailPageRoutingModule {
}
